export default {"src":"/_next/static/media/circle-flag-en.4243ff56.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};